import { sendPasswordResetEmail } from "@firebase/auth";
import { useState, type FormEvent } from "react";
import { AuthCard, Layout } from "../components/Layout";
import { Field, FormError, SubmitButton } from "../components/Form";
import { firebaseAuth } from "../firebase";
import { errorMessage } from "../messages";
import { Link } from "../router";
import { isEmail } from "../validation";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [formError, setFormError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setFormError(null);
    if (!isEmail(email)) {
      setFormError("כתובת האימייל לא תקינה.");
      return;
    }
    setBusy(true);
    try {
      await sendPasswordResetEmail(firebaseAuth(), email.trim(), { url: `${location.origin}/login` });
      setSent(true);
    } catch (error) {
      setFormError(errorMessage(error));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Layout>
      <AuthCard title="איפוס סיסמה" subtitle="נשלח לכם קישור לבחירת סיסמה חדשה.">
        {sent ? (
          <p className="alert alert-success" role="status">
            אם קיים חשבון עם הכתובת {email.trim()}, שלחנו אליה קישור לאיפוס הסיסמה. כדאי לבדוק גם בתיקיית הספאם.
          </p>
        ) : (
          <form onSubmit={(event) => void submit(event)} noValidate>
            <Field
              label="אימייל"
              type="email"
              dir="ltr"
              value={email}
              onChange={setEmail}
              autoComplete="email"
              inputMode="email"
            />
            <FormError message={formError} />
            <SubmitButton busy={busy}>שליחת קישור</SubmitButton>
          </form>
        )}
        <p className="switch">
          <Link to="/login">חזרה להתחברות</Link>
        </p>
      </AuthCard>
    </Layout>
  );
}
